export const COLORS = {
  grayscaleBlack80: 'rgba(57, 64, 73, 0.8)',
  grayscaleBlack40: 'rgba(57, 64, 73, 0.4)',
  grayscaleVeryDarkBlue: '#292D32',
  grayscale900: '#14171A',
  grayscale800: '#282E34',
  grayscale700: '#3D444D',
  grayscale600: '#515B67',
  grayscale500: '#657281',
  grayscale400: '#828D99',
  grayscale300: '#A0A8B1',
  grayscale200: '#BDC2C9',
  grayscale100: '#D9DCE0',
  grayscale50: '#F7F8F9',
  grayscale0: '#FBFCFE',
  primary500: '#4C4098',
  primary400: '#6656CB',
  primary300: '#7F6BFE',
  primary200: '#9787FE',
  primary100: '#B0A3FE',
  primary50: '#C8BFFF',
  primary25: '#DFDAFF',
  primary5: '#F9F8FF',
  secondary500: '#659814',
  secondary400: '#86CB1A',
  secondary300: '#A8FE21',
  secondary200: '#B9FE4B',
  secondary100: '#C9FE75',
  secondary50: '#DAFFA0',
  secondary25: '#E9FFC8',
  systemSuccess: '#00B26B',
  systemWarning: '#FCDA73',
  isTop: '#FFF495',
  darkRed: '#B8362D',
  systemError: '#F06060',
  systemErrorLight: '#F2A1A1',
  systemErrorExtraLightRed: '#FFF6F6',
  elementsStates: '#3DAE9F',
  elementsStatesHover: '#56B39E',
  elementsStatesPressed: '#439D8E',
  elementsStatesFocusedBorder: '#0077EA33',
  shadowDark: '#f4f5f6',
  whiteDark600: '#F6F6F3',
  white: '#FFFFFF',
  white1: 'rgba(255, 255, 255, 0.01)',
  white50: 'rgba(255, 255, 255, 0.05)',
  white100: 'rgba(255, 255, 255, 0.10)',
  white200: 'rgba(255, 255, 255, 0.20)',
  white300: 'rgba(255, 255, 255, 0.30)',
  white400: 'rgba(255, 255, 255, 0.40)',
  white500: 'rgba(255, 255, 255, 0.50)',
  white600: 'rgba(255, 255, 255, 0.60)',
  white700: 'rgba(255, 255, 255, 0.70)',
  white800: 'rgba(255, 255, 255, 0.80)',
  black: '#14171A',
  black1: 'rgba(20, 23, 26, 0.01)',
  black50: 'rgba(20, 23, 26, 0.05)',
  black100: 'rgba(20, 23, 26, 0.10)',
  black200: 'rgba(20, 23, 26, 0.20)',
  black300: 'rgba(20, 23, 26, 0.30)',
  black400: 'rgba(20, 23, 26, 0.40)',
  black500: 'rgba(20, 23, 26, 0.50)',
  black600: 'rgba(20, 23, 26, 0.60)',
  black700: 'rgba(20, 23, 26, 0.70)',
  black800: 'rgba(20, 23, 26, 0.80)',
  lightGreen: '#E1FAEE',
  darkGreen: '#22494A',
  green: '#64AB8A',

  lightGreen10: 'rgba(61, 174, 159, 0.1)',
  lightGreen30: 'rgba(61, 174, 159, 0.3)',
  lightGreen50: 'rgba(61, 174, 159, 0.5)',

  red0: '#F76E6E',
  red100: '#FF7070',
  blue300: '#6AB5FB',
  blue400: '#389DFF',

  gray1: '#212731',
  Gray98: '#FAFAFA',
  DarkGray: '#939AA3',

  // askona
  askonaLight: '#85C5CA',

  caption: '#515B67',
};
